module.exports = __webpack_public_path__ + "img/brand (35).ed03e740.png";